import { Boundaries } from "@planzone/core";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State } from "./types";

function handleFailure(
  state: State,
  { namespace }: Boundaries["retrieveResourceGroups"]["failure"],
): State {
  return state.map((result) =>
    result.namespace === namespace
      ? { ...result, request: setRequestStateToFailure() }
      : result,
  );
}

export { handleFailure };
